<template>
	<div class="container pt-6 pb-10">
		<div class="flex flex-col items-start sm:flex-row sm:justify-between sm:items-center gap-2 py-2 mb-4">
			<h1 class="page-title">Comenzi active</h1>
			<div class="flex flex-row flex-wrap flex-grow-0 gap-4">
				<v-btn to="/comenzi/add" color="teal" class="uppercase" dark>
					Adauga comanda
				</v-btn>
				<v-btn to="/comenzi/finalizate" color="blue-grey" class="uppercase" dark>
					Comenzi finalizate
				</v-btn>
			</div>
		</div>

		<div class="flex flex-row justify-end mb-4">
			<!-- <div class="w-60 monthpicker">
				<span>Selecteaza luna: </span>
				<vue-monthly-picker class="month-picker" :monthLabels="monthLabels" dateFormat="MMMM YYYY"
					v-model="selectedMonth"></vue-monthly-picker>
			</div> -->
		</div>
		<div class="light-grey rounded mb-4 p-4">
			<div class="flex flex-col lg:flex-row lg:justify-between lg:items-center gap-2 lg:gap-10 w-full">
				<div class="w-full lg:w-1/2 flex flex-row items-center gap-2">
					<v-text-field v-model="filterInput" clearable flat solo hide-details
						prepend-inner-icon="mdi-magnify" label="Cauta oferta dupa client"></v-text-field>
					<!-- <v-text-field v-model="searchClient" clearable flat solo hide-details @keydown.enter="searchOffers"
						@click:clear="resetInitialOffers" prepend-inner-icon="mdi-magnify"
						label="Cauta oferta dupa client">
					</v-text-field>
					<v-btn color="blue-grey" class="uppercase" large dark @click="searchOffers">Cauta</v-btn> -->
				</div>

				<div class="flex flex-col sm:flex-row items-stretch sm:items-center gap-2 w-full lg:w-auto">
					<v-select ref="selectAgent" v-model="filterAgent" class="w-full sm:w-60" :items="agents"
						item-text="username" item-value="id_user"
						:clearable="['admin', 'superuser', 'user'].includes(user.rol)"
						@click:clear="$refs.selectAgent.blur()" label="Intocmit de" solo hide-details></v-select>
					<div class="w-full sm:w-60">
						<v-menu v-model="monthpickerMenu" class="w-full" :close-on-content-click="false" left
							transition="scale-transition" offset-y min-width="auto">
							<template v-slot:activator="{ on, attrs }">
								<v-text-field ref="selectMonth" v-model="monthText" class="date-field"
									:class="{ 'opacity-60': isOffersSearchList }" label="Toate lunile" solo
									prepend-inner-icon="mdi-calendar" hide-details clearable readonly
									@click:clear="$refs.selectMonth.blur()" v-bind="attrs" v-on="on"></v-text-field>
							</template>
							<v-date-picker v-model="selectedMonth" no-title type="month"></v-date-picker>
						</v-menu>
					</div>

				</div>
			</div>
		</div>

		<div v-if="loading" class="progress">
			<div class="indeterminate"></div>
		</div>

		<div v-else>
			<Comanda v-for="comanda in filterBy(
				comenzi,
				filterInput,
				filterAgent,
				filterFirma,
				firstday,
				lastday
			)" :key="comanda.id_comanda" :comanda="comanda" @loadClientData="loadClientData" @loadFisa="openShippingModal"
				@loadOferta="openOfferModal" @trimiteStatus="openStatusModal" @problemaComanda="openProblemModal"
				@finalizareComanda="openFinalModal" @deleteComanda="openDeleteModal">
			</Comanda>
		</div>

		<!-- MODALS -->
		<!-- Modal Livrare -->
		<v-dialog v-model="visibleShippingModal" width="60%">
			<v-card>
				<v-card-title>
					Genereaza fisa marfa pentru livrare
				</v-card-title>
				<v-card-text>
					<FisaDepozit :matDepozit="matDepozit" :adresaLivrare="adresaLivrare" :client="selectedClient"
						:idComanda="selectedComanda" @closeShippingModal="visibleShippingModal = false"></FisaDepozit>
				</v-card-text>
			</v-card>
		</v-dialog>

		<!-- Modal Offer -->
		<v-dialog v-model="visibleOfferModal" width="340px">
			<v-card>
				<v-card-title>
					Documente oferta {{ currentOferta }}
				</v-card-title>
				<v-card-text>
					<button v-if="ofertaReady" href="#!" class="btn mbottom-10 modal-close"
						v-on:click="downloadOferta()">
						<i class="material-icons left">file_download</i>Descarca Oferta
					</button>
					<button v-if="proformaReady" href="#!" class="btn cyan darken-2 mbottom-10 modal-close"
						v-on:click="downloadProforma()">
						<i class="material-icons left">file_download</i>Descarca Proforma
					</button>
				</v-card-text>
				<div class="flex flex-row justify-end gap-2 p-6">
					<v-btn class="uppercase" @click="visibleOfferModal = false">Anuleaza</v-btn>
				</div>
			</v-card>
		</v-dialog>

		<!--  Modal Status Comanda -->
		<v-dialog v-model="visibleStatusModal" width="400px">
			<v-card>
				<v-card-title>
					Trimite status
				</v-card-title>
				<v-card-text>
					<div class="flex flex-row items-center gap-1 mb-2">
						<v-label>Client:</v-label>
						<span class="text-lg text-black">{{ selectedClient.nume }}</span>
					</div>
					<div class="flex flex-row items-center gap-1 mb-2">
						<v-label>Email:</v-label>
						<span class="text-lg text-black">{{ selectedClient.email }}</span>
					</div>
				</v-card-text>
				<div class="flex flex-row justify-end gap-2 p-6">
					<v-btn class="uppercase" @click="visibleStatusModal = false">Anuleaza</v-btn>
					<v-btn color="teal" class="white--text uppercase" @click="sendStatus">Trimite</v-btn>
				</div>
			</v-card>
		</v-dialog>

		<!--  Modal Problema Comanda -->
		<v-dialog v-model="visibleProblemModal" width="400px">
			<v-card>
				<v-card-title>
					Adaugati o problema la comanda nr. {{ selectedComanda }} ?
				</v-card-title>
				<v-card-text>
					<v-text-field v-model="problemaComanda.text" outlined dense></v-text-field>
				</v-card-text>
				<div class="flex flex-row justify-end gap-2 p-6">
					<v-btn class="uppercase" @click="visibleProblemModal = false">Anuleaza</v-btn>
					<v-btn color="teal" class="white--text uppercase" @click="saveProblemaComanda">Salveaza</v-btn>
				</div>
			</v-card>
		</v-dialog>

		<!--  Modal Finalizeaza Comanda -->
		<v-dialog v-model="visibleFinalizeModal" width="400px">
			<v-card>
				<v-card-title>
					Finalizeaza comanda nr. {{ selectedComanda }} ?
				</v-card-title>
				<v-card-text>
					<v-alert type="info" outlined dense>
						Toate reperele din comanda vor avea statusul de livrare - <strong>"livrare
							finalizata"</strong>
					</v-alert>
				</v-card-text>
				<div class="flex flex-row justify-end gap-2 p-6">
					<v-btn class="uppercase" @click="visibleFinalizeModal = false">Anuleaza</v-btn>
					<v-btn color="teal" class="white--text uppercase" @click="finalizareComanda">Finalizeaza</v-btn>
				</div>
			</v-card>
		</v-dialog>

		<!--  Modal Delete Comanda -->
		<v-dialog v-model="visibleDeleteModal" max-width="340px">
			<v-card>
				<v-card-title>
					Sterge definitiv comanda nr. {{ selectedComanda }}?
				</v-card-title>
				<div class="flex flex-row justify-end gap-2 mt-4 p-4">
					<v-btn class="uppercase" @click="visibleDeleteModal = false">Anuleaza</v-btn>
					<v-btn color="red darken-1" class="white--text uppercase" @click="deleteComanda">Sterge</v-btn>
				</div>
			</v-card>
		</v-dialog>

		<!-- <pre>{{agents}}</pre> -->
		<!-- <pre>{{ofertaReady}}</pre> -->
		<!-- <pre>{{oferta}}</pre> -->
		<!-- <pre>{{$data}}</pre> -->
		<!-- <pre>{{comenzi}}</pre> -->
	</div>
</template>

<script>
import firebase from "firebase/app";
import FisaDepozit from "@/components/Comenzi/FisaDepozit";
import Comanda from "@/components/Comenzi/Comanda";
import moment from "moment";
import { pdf_oferta_materie_prima } from "@/documents/oferta/pdf_oferta_materie_prima.js";
import { pdf_proforma_materie_prima } from "@/documents/proforma/pdf_proforma_materie_prima.js";

// import VueMonthlyPicker from "vue-monthly-picker";

export default {
	name: "Comenzi",
	data() {
		return {
			user_email: firebase.auth().currentUser.email,
			monthpickerMenu: false,
			visibleOfferModal: false,
			visibleShippingModal: false,
			visibleStatusModal: false,
			visibleProblemModal: false,
			visibleFinalizeModal: false,
			visibleDeleteModal: false,
			selectedMonth: null,
			selectedUser: null,
			monthLabels: [
				"ian",
				"feb",
				"mar",
				"apr",
				"mai",
				"iun",
				"iul",
				"aug",
				"sep",
				"oct",
				"noi",
				"dec",
			],
			filterInput: "",
			filterFirma: 0,
			clear: "true",
			props: {
				dateFormat: "MMMM YYYY",
				clearOption: true,
			},
			currentOferta: "",
			selectedComanda: "",
			selectedClient: {},
			matDepozit: [],
			adresaLivrare: "",
			problemaComanda: {
				status: true,
				text: "transport furnizor intarziat",
			},
			docType: "Oferta",
		};
	},
	components: {
		FisaDepozit,
		Comanda,
		// VueMonthlyPicker,
	},
	computed: {
		monthText: {
			get() {
				return this.$options.filters.formatMonth(this.selectedMonth)
			},
			set() {
				this.selectedMonth = null
			}
		},
		comenzi() {
			return this.$store.getters.comenziActive;
		},
		user() {
			return this.$store.getters.loggedUser;
		},
		loading() {
			return this.$store.getters.loading;
		},
		oferta() {
			return this.$store.getters.oferta;
		},
		ofertaReady() {
			if (this.oferta.id == this.currentOferta) {
				return true;
			} else {
				return false;
			}
		},
		proforma() {
			return this.$store.getters.proforma;
		},
		proformaReady() {
			if (this.proforma.oferta_id == this.currentOferta) {
				return true;
			} else {
				return false;
			}
		},
		pdfName() {
			return `Oferta nr. ${this.oferta.id} ${this.oferta.nume}`;
		},
		proformaName() {
			return `Proforma nr. ${this.proforma.id_proforma} ${this.oferta.nume}`;
		},
		// firstday() {
		// 	if (this.selectedMonth) {
		// 		return this.selectedMonth.startOf("month").format("YYYY-MM-DD");
		// 	}
		// },
		// lastday() {
		// 	if (this.selectedMonth) {
		// 		return this.selectedMonth.endOf("month").format("YYYY-MM-DD");
		// 	}
		// },
		firstday() {
			return new Date(this.selectedMonth).toISOString().split('T')[0]
		},
		lastday() {
			return new Date(new Date(this.selectedMonth).getFullYear(), new Date(this.selectedMonth).getMonth() + 1, 1).toISOString().split('T')[0]
		},
		isOffersSearchList() {
			// return this.$store.getters.isOffersSearchList
			return false
		},
		filterAgent: {
			get: function () {
				return this.selectedUser
			},
			// setter
			set: function (newValue) {
				this.selectedUser = newValue
			},
		},
		agents() {
			let array = [];
			let user = {};

			this.comenzi.forEach((comanda) => {
				user = {
					id_user: comanda.id_user,
					username: comanda.username,
				};
				if (this.containsObject(user, array)) {
					return;
				} else {
					array.push(user);
				}
			});
			return array.filter(this.onlyUnique);
		}
	},
	watch: {
		selectedMonth(newVal, oldVal) {
			if (newVal != oldVal) {
				this.changeMonth()
			}
		}
	},
	methods: {
		replaceSpecialCh(str) {
			return str
				.replace(/ș|Ș/g, "s")
				.replace(/ț|Ț/g, "t")
				.replace(/î|Î/g, "i")
				.replace(/ă|â|Â|Ă/g, "a");
		},
		formatPhoneNo(str) {
			if (str.charAt(0) == "+" || str.charAt(0) == "(") {
				return str;
			} else {
				return "+4" + str;
			}
		},
		changeMonth() {
			this.monthpickerMenu = false
			this.fetchComenzi()
		},
		fetchComenzi() {
			let monthObj = null
			if (this.selectedMonth) {
				monthObj = {
					date1: this.firstday,
					date2: this.lastday,
				}
			}
			this.$store.dispatch("fetchComenziActive", monthObj);
		},
		// fetchComenziOnLoad() {
		// 	this.$store.dispatch("fetchComenziActive");
		// },
		fetchUser() {
			let mail = this.user_email;
			this.$store.dispatch("fetchUser", mail);
		},
		filterBy(list, value) {
			if (!value) {
				value = ""
			}
			value = value.toLowerCase();
			// See if current user has comenzi
			// let has = this.agents.find(function (item) {
			// 	return item.id_user == agent;
			// });
			//filter different cases
			return list.filter((comanda) => {
				// if (has == undefined) {
				// 	if (this.selectedMonth) {
				// 		return (
				// 			comanda.nume.toLowerCase().indexOf(value) > -1
				// 		);
				// 	} else {
				// 		return comanda.nume.toLowerCase().indexOf(value) > -1;
				// 	}
				// } else if (firma == 0) {
				// 	if (this.selectedMonth) {
				// 		return (
				// 			comanda.id_user.indexOf(agent) > -1 &&
				// 			comanda.nume.toLowerCase().indexOf(value) > -1 
				// 		);
				// 	} else {
				// 		return (
				// 			comanda.id_user.indexOf(agent) > -1 &&
				// 			comanda.nume.toLowerCase().indexOf(value) > -1
				// 		);
				// 	}
				// } else {
				// 	if (this.selectedMonth) {
				// 		return (
				// 			comanda.id_user.indexOf(agent) > -1 &&
				// 			comanda.nume.toLowerCase().indexOf(value) > -1
				// 		);
				// 	} else {
				// 		return (
				// 			comanda.id_user.indexOf(agent) > -1 &&
				// 			comanda.nume.toLowerCase().indexOf(value) > -1
				// 		);
				// 	}
				// }
				return (
					comanda.nume.toLowerCase().indexOf(value) > -1
				);
			});
		},
		onlyUnique(value, index, arr) {
			return arr.indexOf(value) === index;
		},
		containsObject(obj, list) {
			var i;
			for (i = 0; i < list.length; i++) {
				if (list[i].id_user === obj.id_user) {
					return true;
				}
			}
			return false;
		},
		dimensiune_text(produs) {
			let str = produs.dimL;
			if (produs.dimH) {
				str += " x " + produs.dimH;
			}
			if (produs.dimG) {
				str += " x " + produs.dimG;
			}
			if (str == null || str == "") {
				return "";
			} else {
				if (!produs.dimH && !produs.dimG) {
					str = "D " + str;
				}
				return str + " mm";
			}
		},
		loadClientData(obj) {
			this.selectedClient = obj;
		},
		openShippingModal(obj) {
			this.matDepozit = obj.materiale;
			this.adresaLivrare = obj.adresa;
			this.selectedComanda = obj.id;
			this.visibleShippingModal = true
		},
		openOfferModal(ofertaId) {
			this.currentOferta = ofertaId;
			this.visibleOfferModal = true
		},
		openStatusModal(id) {
			this.selectedComanda = id;
			this.visibleStatusModal = true
		},
		openProblemModal(id) {
			this.selectedComanda = id;
			this.visibleProblemModal = true
		},
		openFinalModal(id) {
			this.selectedComanda = id;
			this.visibleFinalizeModal = true
		},
		openDeleteModal(id) {
			this.selectedComanda = id;
			this.visibleDeleteModal = true
		},
		async downloadOferta() {
			const doc = await pdf_oferta_materie_prima.createOfertaMateriePrimaPDF(this.oferta, this.pdfExtraInfo, this.daysText);
			let pdfName = `Oferta nr. ${this.oferta.id} ${this.oferta.nume}`;
			doc.save(pdfName + ".pdf");

		},
		async downloadProforma() {
			const doc = await pdf_proforma_materie_prima.createProformaMateriePrimaPDF(this.proforma);
			let pdfName = `Proforma nr. ${this.proforma.id_proforma} ${this.proforma.nume}`;
			doc.save(pdfName + ".pdf");
		},
		sendStatus() {
			let comanda = this.comenzi.find((obj) => {
				return obj.id_comanda === this.selectedComanda;
			});
			let produse = comanda.produse_obj;
			let self = this;

			let table = `<table style="min-width: 438px; border: 1px solid grey; font-size: 13px; border-collapse: collapse;">
						<thead>
						<tr style="text-align: left; background-color: #f3f4f8;">
						<th style="border: 1px solid black; padding: 10px;">Nr.</th>
						<th style="border: 1px solid black; padding: 10px;">Produs</th>
						<th style="border: 1px solid black; padding: 10px;">Cantitate</th>
						<th style="border: 1px solid black; padding: 10px; width: 68px;">Data livrare</th>
						<th style="border: 1px solid black; padding: 10px; width: 68px;">Data livrare actualizata</th>
						<th style="border: 1px solid black; padding: 10px;">Status livrare</th>
						</tr>
						</thead>
						<tbody>`;

			produse.forEach(function (produs) {
				let detalii = produs.detalii;
				if (detalii && detalii != "") {
					detalii = " - " + detalii;
				}
				let dim = self.dimensiune_text(produs);
				if (dim == "") {
					dim = produs.dimensiune;
				}
				let data_livrare = produs.data_livrare;
				if (data_livrare == undefined || data_livrare == null) {
					data_livrare = "-";
				}
				let data_actualizata = produs.data_actualizata;
				if (data_actualizata == undefined || data_actualizata == null) {
					data_actualizata = "-";
				}
				let status_livrare = produs.status_livrare;
				if (status_livrare == undefined || status_livrare == null) {
					status_livrare = "-";
				}

				table +=
					`
        <tr>
        <td style="border: 1px solid black; text-align: center; padding: 4px;">` +
					produs.nr +
					`</td>

        <td style="border: 1px solid black; padding: 4px;">`;

				if (produs.denumire.value) {
					table +=
						"" +
						produs.denumire.value +
						" " +
						produs.material +
						detalii +
						", " +
						produs.dimensiune +
						", aliaj: " +
						produs.aliaj;
				} else {
					table +=
						"" +
						produs.denumire +
						" " +
						produs.material +
						detalii +
						" " +
						produs.dimensiune +
						", aliaj: " +
						produs.aliaj;
				}

				table +=
					`</td>

        <td style="border: 1px solid black; text-align: right; padding: 4px;">` +
					produs.cantitate +
					" " +
					produs.um +
					`</td>
        <td style="border: 1px solid black; text-align: center; padding: 4px;">` +
					data_livrare +
					`</td>`;
				if (produs.status_livrare === "livrare anulata") {
					table += `<td style="border: 1px solid black; text-align: center; padding: 4px;">-</td>`;
				} else {
					if (produs.data_livrare === produs.data_actualizata) {
						table +=
							`<td style="border: 1px solid black; text-align: center; color: #4caf50; padding: 4px;">` +
							data_actualizata +
							`</td>`;
					} else {
						table +=
							`<td style="border: 1px solid black; text-align: center; color: #e53935; padding: 4px;">` +
							data_actualizata +
							`</td>`;
					}
				}
				if (produs.status_livrare === "livrare finalizata") {
					table +=
						`<td style="border: 1px solid black; color: #4caf50; padding: 4px; font-weight: 700;">` +
						status_livrare +
						`</td>`;
				} else if (produs.status_livrare === "livrare anulata") {
					table +=
						`<td style="border: 1px solid black; color: #e53935; padding: 4px; font-weight: 700;">` +
						status_livrare +
						`</td>`;
				} else {
					table +=
						`<td style="border: 1px solid black; padding: 4px; font-weight: 700;">` +
						status_livrare +
						`</td>`;
				}
				table += `</tr>`;
			});

			table +=
				`<tr><td colspan="6" style="border: 1px solid black; padding: 4px;"><span style="font-weight: 700;">Stare comanda: </span>` +
				comanda.stare +
				`</td></tr>`;
			if (comanda.obs) {
				table +=
					`<tr><td colspan="6" style="padding: 4px;"><span style="font-weight: 700;">Detalii: </span>` +
					comanda.obs +
					`</td></tr>`;
			}

			table += `</tbody></table>`;

			let mailComanda = {
				nr_comanda: comanda.id_comanda,
				client_mail: comanda.email,
				data_comanda: moment(String(comanda.data)).format("DD/MM/YYYY"),
				table: table,
				obs: comanda.obs,
			};

			// Send status to php script for emailing forward
			this.$http
				.post(
					process.env.VUE_APP_HUB_API_HOST + "email/vanzari/comanda_status",
					mailComanda,
					{
						headers: { x_api_key: process.env.VUE_APP_HUB_API_KEY },
					}
				)
				.then(function (response) {
					comanda.ultimul_status = moment()
						.format()
						.slice(0, 19)
						.replace("T", " ");

					this.$store.dispatch("updComandaStatus", {
						id: comanda.id_comanda,
						object: {
							ultimul_status: comanda.ultimul_status,
						},
					});

					M.toast({ html: response.body, classes: "blue" });
				})
				.catch(function (error) {
					console.log(error.body);
					M.toast({
						html: "Eroare! Emailul nu a fost trimis",
						classes: "red darken-1",
					});
				});
		},
		saveProblemaComanda() {
			this.$store.dispatch("saveProblemaComanda", {
				id: this.selectedComanda,
				object: {
					status: this.problemaComanda.status,
					problema_text: this.problemaComanda.text,
				},
			});
			this.visibleProblemModal = false
		},
		finalizareComanda() {
			let comanda = this.comenzi.find((obj) => {
				return obj.id_comanda === this.selectedComanda;
			});
			comanda.produse_obj.forEach(function (produs) {
				produs.status_livrare = "livrare finalizata";
			});

			this.$store.dispatch("finalizeazaComanda", {
				object: {
					stare: "finalizata",
					produse_obj: JSON.stringify(comanda.produse_obj),
				},
				id: this.selectedComanda,
			});
			this.visibleFinalizeModal = false
		},
		deleteComanda() {
			this.$store.dispatch("deleteComanda", this.selectedComanda);
			this.visibleDeleteModal = false
		},
	},
	created: function () {
		this.fetchComenzi();
		this.fetchUser();
		this.$store.dispatch("fetchCurrency");
	},
	mounted: function () {
		M.Modal.init(document.querySelectorAll(".modal"));

		if (this.user.rol == 'admin') {
			this.selectedUser = null
		} else {
			this.selectedUser = this.user.id_user
		}
	},
	updated: function () {
		M.FormSelect.init(document.querySelectorAll("select"));
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#dropdown {
	transform: translate(0, -25px);
}

.no-lp {
	padding-left: 0;
}

.no-rp {
	padding-right: 0;
}

.switch-comenzi {
	margin-right: 630px;
}

.legend {
	margin-right: 110px;
}

.legend i {
	vertical-align: middle;
	margin-right: 10px;
}

td.status label {
	margin-left: 6px;
}

.monthpicker span {
	color: #9e9e9e;
	font-size: 0.8rem;
}

/* .monthpicker .month-picker .month-picker-wrapper {
  background: transparent;
  border: none;
  box-shadow: none;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  padding: 19px;
  border-bottom: 1px solid #9e9e9e;
} */
</style>
